import React from 'react'
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom'

import SignalR from './components/molecules/signalR/signalR'

import StoreProvider from './store/Provider'
import AppRoute from './routes/Route'
import Dashboard from './pages/Dashboard'
import Undock from './pages/Undock'
import Signin from './pages/Auth/Signin'
import SigninSSO from './pages/Auth/SigninSSO'
import PasswordRecover from './pages/Auth/PasswordRecover'
import PasswordReset from './pages/Auth/PasswordReset'
import { AutomaticSummarizationProvider } from './providers/AutomaticSummarizationProvider'
import ExpirePassword from './pages/Auth/ExpirePassword'

const App = () => {
  return (
    <Router>
      <AutomaticSummarizationProvider>
        <StoreProvider>
          <SignalR />
          <Switch>
            <Route path="/login" render={(props) => {
              const { search } = props.location;
              return <Redirect to={`/signin${search}`} />;
            }} />
            <AppRoute path="/signin" component={Signin} isLogin={true} />
            <AppRoute path="/signinSSO/:data" component={SigninSSO} />
            <AppRoute path="/password-recover" component={PasswordRecover} />
            <AppRoute
              path="/password-reset/:token"
              component={PasswordReset}
            />
            <AppRoute path="/expire-password" component={ExpirePassword} />
            <AppRoute
              path="/reset-password/:token"
              component={PasswordReset}
            />
            <AppRoute
              path="/dashboard"
              component={Dashboard}
              isProtected={true}
            />
            <AppRoute
              path="/undock/:panel"
              component={Undock}
              isProtected={true}
            />
            <AppRoute path="/" isRoot={true} isProtected={true} />
          </Switch>
        </StoreProvider>
      </AutomaticSummarizationProvider>
    </Router>
  )
}

export default App
